// The `custom-notifications` response header — the backend attaches it to
// every API response as a JSON string carrying the signed-in user's live
// counters. Only `unread-notifications` is consumed today (the header bell
// badge, via notificationsSlice); the other two fields are typed because the
// contract is confirmed, not because anything reads them yet.

/** Axios lowercases header keys, so this is the lookup key as well. */
export const CUSTOM_NOTIFICATIONS_HEADER = 'custom-notifications';

export interface CustomNotificationsHeader {
  'unread-notifications': number;
  'pending-invitations': number;
  'is-company-active': boolean;
}

/** The parsed unread count, or `undefined` when the response carried no
 *  header (public endpoints, non-company sessions). Parses strictly — a
 *  malformed header is a backend bug and should surface, not be masked. */
export const readUnreadNotifications = (
  headers: Record<string, unknown> | undefined,
): number | undefined => {
  const raw = headers?.[CUSTOM_NOTIFICATIONS_HEADER];
  if (typeof raw !== 'string') return undefined;
  return (JSON.parse(raw) as CustomNotificationsHeader)['unread-notifications'];
};
